import PropTypes from 'prop-types';
import { ConditionalRender } from '../../../conditionally-render/ConditionalRender';
import { MenuCategoryDesktop } from './menu-category-desktop';
import { MenuCategoryMobile } from './menu-category-mobile';

interface Props {
    isOpen: boolean;
    onClose: () => void;
}

export const MenuCategory: React.FC<Props> = ({ isOpen, onClose }) => (
    <>
        <ConditionalRender visibility={{ base: true, md: false }}>
            <MenuCategoryMobile isOpen={isOpen} onClose={onClose} />
        </ConditionalRender>
        <ConditionalRender visibility={{ base: false, md: true }}>
            <MenuCategoryDesktop />
        </ConditionalRender>
    </>
);

MenuCategory.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};
